var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { staticClass: "flex-box" },
        [
          _c(
            "el-col",
            { staticClass: "flex-left" },
            [
              !_vm.isDetail
                ? _c(
                    "el-card",
                    {
                      staticClass: "card-box",
                      attrs: {
                        "body-style": { padding: "12px 20px 20px 20px" },
                      },
                    },
                    [
                      _c("div", { staticClass: "v-height-flag" }, [
                        _c("div", { staticClass: "main" }, [
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _c(
                                "div",
                                { staticClass: "notice-nav-content" },
                                [
                                  _c(
                                    "el-tabs",
                                    {
                                      on: { "tab-click": _vm.handleClick },
                                      model: {
                                        value: _vm.activeName,
                                        callback: function ($$v) {
                                          _vm.activeName = $$v
                                        },
                                        expression: "activeName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.noticeNav,
                                      function (item, index) {
                                        return _c("el-tab-pane", {
                                          key: index,
                                          attrs: {
                                            label: item.cate_name,
                                            name: index.toString(),
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.tableData.length > 0
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "v-height-flag" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "notice-box" },
                                          [
                                            _c(
                                              "ul",
                                              { staticClass: "notice-content" },
                                              _vm._l(
                                                _vm.tableData,
                                                function (item) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: item.id,
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.itemDetail(
                                                            item.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-row",
                                                        {
                                                          attrs: { gutter: 20 },
                                                        },
                                                        [
                                                          _c(
                                                            "el-col",
                                                            {
                                                              staticClass:
                                                                "notice-left",
                                                              class: item.cover
                                                                ? ""
                                                                : "width",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "title1",
                                                                },
                                                                [
                                                                  item.is_top ===
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "tag",
                                                                          attrs:
                                                                            {
                                                                              size: "mini",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "置顶"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "over-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item.title
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "info over-text2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.info
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "bottom",
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "iconfont iconriqishijian",
                                                                      attrs: {
                                                                        title:
                                                                          "发布时间",
                                                                      },
                                                                    }),
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.push_time
                                                                        ) +
                                                                        "\n                              "
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "iconfont iconyiyuedu",
                                                                      attrs: {
                                                                        title:
                                                                          "阅读次数",
                                                                      },
                                                                    }),
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.visit
                                                                        ) +
                                                                        "\n                              "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          item.cover
                                                            ? _c(
                                                                "el-col",
                                                                {
                                                                  staticClass:
                                                                    "notice-right",
                                                                },
                                                                [
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "image",
                                                                    style: {
                                                                      backgroundImage:
                                                                        "url(" +
                                                                        item.cover +
                                                                        ")",
                                                                    },
                                                                    attrs: {
                                                                      alt: "",
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "page-fixed" },
                                      [
                                        _c("el-pagination", {
                                          attrs: {
                                            "page-size": _vm.where.limit,
                                            "current-page": _vm.where.page,
                                            layout:
                                              "total,prev, pager, next, jumper",
                                            total: _vm.total,
                                          },
                                          on: {
                                            "size-change": _vm.handleSizeChange,
                                            "current-change": _vm.pageChange,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : _c("default-page", {
                                    directives: [
                                      { name: "height", rawName: "v-height" },
                                    ],
                                    attrs: { "min-height": 300, index: 14 },
                                  }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _c("notice-detail", {
                    attrs: { data: _vm.detailData },
                    on: { handleNoticeDetail: _vm.handleNoticeDetail },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "flex-right" },
            [
              _c(
                "el-card",
                { staticClass: "news-right" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("div", { staticClass: "news-title" }, [
                        _c("span", { staticClass: "before" }),
                        _vm._v("\n            最新公告\n          "),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.nweNoticeData.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "news-content" },
                        _vm._l(_vm.nweNoticelist, function (item, index) {
                          return _c(
                            "li",
                            {
                              key: "new" + item.id,
                              on: {
                                click: function ($event) {
                                  return _vm.itemDetail(item.id)
                                },
                              },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "notice-left",
                                      class: item.cover ? "" : "width100",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "title-index" },
                                            [_vm._v(_vm._s(index + 1 + "."))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "title over-text2 blod",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "title-alignment",
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(item.title)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "bottom" }, [
                                        _c("span", [
                                          _c("i", {
                                            staticClass:
                                              "iconfont iconriqishijian",
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.push_time) +
                                              "\n                  "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _c(
                                            "span",
                                            { staticClass: "fixed-right" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont iconyiyuedu",
                                              }),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(item.visit) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c("default-page", {
                        attrs: { "min-height": 360, index: 14 },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }